export enum Op {
  and = 'and',
  or = 'or',
  is = 'is',
  isNot = 'isNot',
  contains = 'contains',
  doesNotContain = 'doesNotContain',
  startsWith = 'startsWith',
  endsWith = 'endsWith',
  isEmpty = 'isEmpty',
  isNotEmpty = 'isNotEmpty',
  relative = 'relative',
  equals = 'equals',
  greaterThan = 'greaterThan',
  lessThan = 'lessThan',
  between = 'between',
  P7D = 'P7D',
  P30D = 'P30D',
  P90D = 'P90D',
  refIds = 'refIds',
  notRefIds = 'notRefIds',
  multiValue = 'multiValue'
}
